// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PasswordChanged_loginFormHeader__9hNBU {
  color: var(--color-font-2);
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 40px;
}

.PasswordChanged_loginForm__QjW6B {
  margin: 40px;
}

.PasswordChanged_link_sent_content__QLoLv {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  align-items: center;
  text-align: center;
}

.PasswordChanged_success_icon__nS7Kv {
  width: 70px !important;
  height: 80px !important;
  color: var(--color-theme-green);
}

.PasswordChanged_go_to_login_button__Yvuru {
  width: 270px;
  height: 41px;
  border: 1px solid var(--color-theme-blue) !important;
  border-radius: 4px;
  background-color: var(--color-theme-white) !important;
  color: var(--color-theme-blue) !important;
  cursor: pointer;
  font-size: 16px;
}

.PasswordChanged_go_to_login_button__Yvuru:hover {
  color: var(--color-theme-white) !important;
  background-color: var(--color-theme-blue) !important;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/ForgotPassword/PasswordChanged/PasswordChanged.module.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,qDAAqD;EACrD,yCAAyC;EACzC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,oDAAoD;AACtD","sourcesContent":[".loginFormHeader {\n  color: var(--color-font-2);\n  font-weight: bold;\n  font-size: 22px;\n  margin-bottom: 40px;\n}\n\n.loginForm {\n  margin: 40px;\n}\n\n.link_sent_content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: space-between;\n  align-items: center;\n  text-align: center;\n}\n\n.success_icon {\n  width: 70px !important;\n  height: 80px !important;\n  color: var(--color-theme-green);\n}\n\n.go_to_login_button {\n  width: 270px;\n  height: 41px;\n  border: 1px solid var(--color-theme-blue) !important;\n  border-radius: 4px;\n  background-color: var(--color-theme-white) !important;\n  color: var(--color-theme-blue) !important;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.go_to_login_button:hover {\n  color: var(--color-theme-white) !important;\n  background-color: var(--color-theme-blue) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginFormHeader": `PasswordChanged_loginFormHeader__9hNBU`,
	"loginForm": `PasswordChanged_loginForm__QjW6B`,
	"link_sent_content": `PasswordChanged_link_sent_content__QLoLv`,
	"success_icon": `PasswordChanged_success_icon__nS7Kv`,
	"go_to_login_button": `PasswordChanged_go_to_login_button__Yvuru`
};
export default ___CSS_LOADER_EXPORT___;
